import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import {getEnabledFilters} from '../common/util'

class FilterCombo extends Component {
    static propTypes = {
        filterId: PropTypes.string.isRequired,
        filterables: PropTypes.object.isRequired,
        actions: PropTypes.object.isRequired,
        heading: PropTypes.string.isRequired
    };

    state = {anchorEl: null}
    
    handleClick(event) {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleClose() {
        this.setState({ anchorEl: null });
    }

    filterAll() {
        let { filterables, enabledFilters } = getEnabledFilters(this.props.filterables, this.props.filterId);
        filterables.forEach(sp => this.props.actions.setFilter(this.props.filterId, sp, true));
    }

    filterNone() {
        let { enabledFilters } = getEnabledFilters(this.props.filterables, this.props.filterId);
        enabledFilters.forEach(sp => this.props.actions.setFilter(this.props.filterId, sp, false));
    }

    onChange(event, sp) {
        this.props.actions.setFilter(this.props.filterId, sp, event.target.checked);
        //console.log({ event, sp });
    }

    render() {
        //console.log("render FilterCombo " + this.props.filterId);
        if (!this.props.filterables)
            return null;
        let { filterables, enabledFilters } = getEnabledFilters(this.props.filterables, this.props.filterId);
        if (filterables.length === 1)
            return null;
        return <div style={{ display:"inline-block"}}>
        <Button
                aria-owns={this.state.anchorEl ? 'simple-menu' : undefined}
    aria-haspopup="true"
                onClick={(evt) => this.handleClick(evt)}
        >
                    {this.props.heading}: {enabledFilters.length === 0 ? "Nichts" : enabledFilters.length === filterables.length ? "Alle" : enabledFilters.map(sp => sp === "" ? "[empty]" : sp).join(",")}
    </Button> <Menu
    id = "simple-menu"
    anchorEl = { this.state.anchorEl }
                open={Boolean(this.state.anchorEl) }
                onClose={this.handleClose.bind(this)} >
                {filterables.map(sp => 
                        <MenuItem  key={sp}><Checkbox checked={enabledFilters.some(esp => esp === sp)} margin="dense" value={"enable_" + sp} onChange={(ctrl) => this.onChange(ctrl, sp)} />{sp === "" ? "[leer]" : sp}</MenuItem>)}
                <MenuItem key="_all" onClick={this.filterAll.bind(this)}> Alle </MenuItem>
                    <MenuItem key="_none" onClick={this.filterNone.bind(this)}>Nichts</MenuItem> </Menu >
               
                <div className=".home-filter-combo-clear"></div>
               </div>;
    }


}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
      filterables: state.home.filterables
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterCombo);



// WEBPACK FOOTER //
// ./src/features/home/FilterCombo.js